<!-- Back-to-top -->
<div class="scrollToTop" (click)="taptotop()" [ngStyle]="{ display: show ? 'flex' : 'none' }">
  <span class="arrow"><i class="ti ti-arrow-narrow-up fs-20"></i></span>
</div>
